import { getService } from "@/api/im.js";
export default {
    namespaced: true,
    state: {
        serviceChatId: null,
    },
    mutations: {
        setServiceChatId(state, data) {
            state.serviceChatId = data;
        },
    },
    actions: {
        // 初始化客服id
        initServiceChatId({ commit, state }, reload = false) {
            return new Promise((resolve, reject) => {
                if (state.serviceChatId === null || reload) {
                    getService({}).then(res => {
                        if (res.code == 0) {
                            commit("setServiceChatId", res.data?.chat_id || null);
                            resolve(state.serviceChatId);
                        }
                    })
                } else {
                    resolve(state.serviceChatId);
                }
            })

        },
    },
};
